import { HttpClient } from '@angular/common/http'
import { Component } from '@angular/core'
import { NgForm, FormsModule } from '@angular/forms'
import { Router } from '@angular/router'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { AuthenticationService, Services } from '../../shared'
import { NgIf, NgFor } from '@angular/common'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'

@Component({
    templateUrl: './sign-up.component.html',
    styleUrls: ['../sign-in/sign-in.component.css'],
    standalone: true,
    imports: [FormsModule, NgIf, FaIconComponent, NgFor],
})
export class SignUpComponent {
    faSpinner = faSpinner
    isSigningIn = false
    passwordErrors: any[] = []
    public user = {
        username: '',
        password: '',
        confirmPassword: '',
    }

    get isInvalid(): boolean {
        if (!this.user.username || !this.user.password || !this.user.confirmPassword) {
            return true
        }
        return false
    }
    get passwordMismatch(): string {
        if (this.user.password && this.user.confirmPassword && this.user.password !== this.user.confirmPassword)
            return '*Passwords must match'
        return ''
    }
    constructor(
        private http: HttpClient,
        private router: Router,
        private authentication: AuthenticationService,
        private services: Services,
    ) {}

    submitForm(form: NgForm) {
        if (!this.user.username.startsWith('v') && isNaN(+this.user.username)) {
            this.services.notification.warning('Please enter your three or four-digit Employee number or the Lessor account you were sent.')
            return
        }

        if (form.valid) {
            this.isSigningIn = true
            this.http.post('api/Account/signup', this.user).subscribe({
                next: (result: any) => {
                    if (result.succeeded) {
                        this.authentication.completeLogin().subscribe({
                            next: (result: any) => {
                                this.router.navigate([''])
                            },
                            complete: () => {
                                this.isSigningIn = false
                            },
                        })
                    } else {
                        this.passwordErrors = result.errors.map((x: any) => x.description)
                        this.isSigningIn = false
                    }
                },
                error: (err: any) => {
                    this.isSigningIn = false
                },
            })
        }
    }
    signin() {
        this.router.navigate(['signin'])
    }
}
